/**
 * Input.ZipCodeモジュール
 *
 * No.    日付          更新者    更新内容
 *   1    2021/09/10    大友      新規作成
 *
 * @summary データ
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import $ from 'jquery';
import * as Common from '../../_common';
import {Dom} from '../dom';
import {Input} from '../input';

class ZipCode {
    set latitude (value) {
        console.log(value);
        this._latitude = value;
    }
    set longitude (value) {
        console.log(value);
        this._longitude = value;
    }
    constructor (target, address){
        if (typeof target === 'string') {
            this.target = document.querySelector(target);
        } else {
            this.target = target;
        }
        if (this.target === null && typeof this.target === 'undefined') {
            throw 'target が 不正です。';
        }

        this.address = null;
        if (typeof address != 'undefined') {
            this.address = address;
        }

        const wrap = Dom.createElement('div');
        wrap.classList.add('input-group');
        wrap.classList.add('zipcode');

        const button = Dom.createElement('button');
        button.setAttribute('tabindex', -1);
        button.classList.add('btn');
        button.classList.add('btn-search');
        button.classList.add('text-nowrap');
        button.textContent = '検索';

        // wrap
        Dom.wrap(target, wrap);
        wrap.appendChild(button);

        // 入力制御
        Input.numericOnly(target, false);

        const me = this;
        button.addEventListener('click', event => {
            event.stopPropagation();
            event.preventDefault();

            const eArgs = {
                result: false,
                errors: {},
                data: {},
            };

            if (target.value !== '') {
                button.disabled = true;
                const url = Common.Data.Service.PostalCode.Endpoint.replace('{zipcode}', target.value);
                // JSON取得
                $.getJSON(url, {}, function() {})
                    .done(function(json) {
                        // 取得成功(完了)
                        eArgs.result = json.length > 0;

                        var allAddress = '';
                        var location = {};
                        if (eArgs.result) {
                            eArgs.data = json[0];
                            allAddress = json[0].allAddress;
                            location = json[0].location;
                        }

                        me.address.value = allAddress;

                        // 緯度経度
                        console.log(me._latitude, me._longitude);
                        const pow = Math.pow(10, 9);
                        me._latitude.value = Math.round(location.latitude * pow) / pow;
                        me._longitude.value = Math.round(location.longitude * pow) / pow;

                        target.dispatchEvent(new CustomEvent('api.response', {detail: eArgs}));

                        return;
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        // 取得失敗
                        console.log([jqXHR, textStatus, errorThrown]);
                        eArgs.errors = {
                            textStatus: textStatus,
                            errorThrown: errorThrown,
                        };

                        if (me.address !== null) {
                            me.address.value = '';
                        }

                        target.dispatchEvent(new CustomEvent('api.response', {detail: eArgs}));
                    })
                    .always(function() {
                        // 完了
                        button.disabled = false;
                    });
            }
        }, false);
    }
}

export {ZipCode};
